import {IReportData, emptyReportData} from "../../entities/reports/IReportData";
import {FetchState} from "../../entities/FetchState";
import { Reducer } from "redux";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import Either from "../../utils/Either";
import {callApiWithResult, ICallResult, IError} from "../../utils/callApi";


/**********************************************************
 * API Data
 **********************************************************/
export interface IData {
    id: string
    name: string
}
export const defaultDisabilitiesList: IReportData<IData> = emptyReportData()

/**********************************************************
 * State
 **********************************************************/

export interface IState {
    DisabilitiesList: IReportData<IData>
}
export const InitialState: IState = {
    DisabilitiesList: defaultDisabilitiesList
}

/**********************************************************
 * Action Types
 **********************************************************/
export enum ActionTypes {
    FetchData = "disabilities.DisabilitiesList Fetch",
    FetchDataSuccess = "disabilities.DisabilitiesList FetchSuccess",
    FetchDataFailed = "disabilities.DisabilitiesList FetchFailed"
}

/**********************************************************
 * Actions & Creators
 **********************************************************/
export interface IFetchData {
    type: ActionTypes.FetchData,
}
export interface IFetchDataSuccess {
    type: ActionTypes.FetchDataSuccess,
    payload: { data: IData[] }
}
export interface IFetchDataFailed {
    type: ActionTypes.FetchDataFailed,
    payload: { errorMessage: string }
}
type Actions = IFetchData | IFetchDataSuccess | IFetchDataFailed;

export class ActionCreators {
    public static FetchData(): IFetchData {
        return { 
            type: ActionTypes.FetchData, 
        };
    }
    public static FetchDataSuccess(newData: IData[]): IFetchDataSuccess {
        return {
            type: ActionTypes.FetchDataSuccess,
            payload: { data: newData }
        };
    }
    public static FetchDataFailed(err: string): IFetchDataFailed {
        return {
            type: ActionTypes.FetchDataFailed,
            payload: { errorMessage: err }
        };
    }
}

/**********************************************************
 * Reducer
 **********************************************************/
export const Reducers: Reducer<IState, Actions> = (state = InitialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchData:
            return { 
                ...state, 
                DisabilitiesList: {
                    ...state.DisabilitiesList,
                    state: FetchState.Busy
                }
            };
        case ActionTypes.FetchDataSuccess:
            return { 
                ...state, 
                DisabilitiesList: {
                    ...state.DisabilitiesList,
                    state: FetchState.Success,
                    data: action.payload.data,
                    fetchDate: new Date()
                }
            };
        case ActionTypes.FetchDataFailed:
            return { 
                ...state, 
                DisabilitiesList: {
                    ...state.DisabilitiesList,
                    state: FetchState.Error,
                    errorMessage: action.payload.errorMessage
                }
            };
        default:
            return state;
    }
}

/**********************************************************
 * Sagas
 **********************************************************/

function* handleIFetchData() {
    try {
        const response : Either<IError, ICallResult<IData[]>> = yield call(callApiWithResult, 'GET', `/v1/Disabilities`);
        yield response
            .FlatMap(success => put(ActionCreators.FetchDataSuccess(success.result) as any))
            .Reduce(error => put(ActionCreators.FetchDataFailed(error.text) as any))
    } catch (err) {
        yield put(ActionCreators.FetchDataFailed(JSON.stringify(err)))
    }
}

function* watchAll() {
    yield takeEvery(ActionTypes.FetchData, handleIFetchData)
}
export function* sagas() {
    yield all([fork(watchAll)]);
}

